export type ContactTopic = {
  slug: string
  key: string
}

export const CONTACT_TOPICS: ContactTopic[] = [
  { slug: 'product-feedback', key: 'topics.productFeedback' },
  { slug: 'bug-report', key: 'topics.bugReport' },
  { slug: 'billing', key: 'topics.billing' },
  { slug: 'partnerships', key: 'topics.partnerships' },
  { slug: 'general', key: 'topics.general' }
]
